import { Component, ElementRef } from '@angular/core';
import { ComponentsService } from '../../services/components.service';
import { AttributeDataService } from '../../services/attribute-data.service';

@Component({
  selector: 'template-component-screen-sharing',
  templateUrl: './screen-sharing.component.html',
  styleUrls: ['./screen-sharing.component.scss'],
  standalone: false,
})
export class ScreenSharingComponent {
  public componentId: string;
  public textColor: string;
  public backgroundColor: string;

  constructor(
    private elementRef: ElementRef,
    private componentsService: ComponentsService,
    private attributeDataService: AttributeDataService,
  ) {
    this.componentsService.registerDirective({
      type: 'rise-screen-sharing',
      element: this.elementRef.nativeElement,
      show: (options?) => {
        this.componentId = this.componentsService.selected.id;

        this.load();
      },
    });
  }

  load() {
    const textColor = this.attributeDataService.getAvailableAttributeData(
      this.componentId,
      'textColor',
    );
    const backgroundColor = this.attributeDataService.getAvailableAttributeData(
      this.componentId,
      'backgroundColor',
    );
    this.textColor = textColor || 'rgba(255, 255, 255, 1)';
    this.backgroundColor = backgroundColor || 'rgba(66, 76, 87, 0.75)';
  }

  onTextColorChange() {
    this.attributeDataService.setAttributeData(
      this.componentId,
      'textColor',
      this.textColor,
    );
  }

  onBackgroundColorChange() {
    this.attributeDataService.setAttributeData(
      this.componentId,
      'backgroundColor',
      this.backgroundColor,
    );
  }
}
